import exoApi from './exoApi'
export default exoApi